<script>
import ProcessesController from "../../../Mixins/ProcessesController";
import HeaderName from "../../../Comps/General/HeaderName.vue";
import AccidentReportTable from "../../../Comps/Staff/AccidentReports/AccidentReportTable.vue";
import Permissions from "../../../Mixins/Permissions";

export default {
    name: "Index",
    components: { AccidentReportTable, HeaderName },

    mixins: [ProcessesController],

    computed: {
        reports() {
            return this.$page.props.reports;
        },
    },

    methods: {
        pageChanged(page) {
            this.$inertia.get(
                this.route("accident-reports.index"),
                {
                    page: page,
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                }
            );
        },
    },
};
</script>

<template>
    <v-container>
        <header-name>Accident Reports</header-name>
        <div class="grey--text subtitle-2">
            <span v-if="$page.props.viewAny">Showing all accident reports</span>
            <span v-else
                >Showing accident reports you were the creator of or affected
                by.</span
            >
        </div>

        <div class="d-flex">
            <inertia-link :href="route('accident-reports.create')">
                <v-btn class="success my-4 ml-sm-auto" small>
                    Create report
                </v-btn>
            </inertia-link>
        </div>
        <v-sheet class="pa-6" elevation="2">
            <accident-report-table
                :reports="reports"
                @page-changed="pageChanged"
                :page="$page.props.reports.current_page"
            />
        </v-sheet>
    </v-container>
</template>
